// extracted by mini-css-extract-plugin
module.exports = {"imageWrapper":"PartnersListItem_imageWrapper__1sU3k","image":"PartnersListItem_image__KKfvv"};